"use client";
import { Link } from "@/navigation";
import { LinkedinLogo, TiktokLogo } from "@phosphor-icons/react";
import React from "react";
import { contactObj } from "@/lib/contacts";
import { useTranslations } from "next-intl";

const FollowUs = ({ className, textClass }: { className?: string; textClass?: string }) => {
	const t = useTranslations();

	return (
		<div className={`mt-6 flex items-center gap-2 ${className}`}>
			<p className="text-sm font-semibold ">{t("base.followOn")}</p>
			<SocialList className={textClass}></SocialList>
		</div>
	);
};
export const SocialList = ({ className }: { className?: string }) => {
	let data = [
		{ icon: "ri-facebook-fill", link: contactObj.FaceBook },
		{ icon: "ri-instagram-line", link: contactObj.Instagram },
		{ icon: "ri-youtube-fill", link: contactObj.Youtube },
		{ icon: "ri-tiktok-fill", link: contactObj.Tiktok },
		{ icon: "ri-linkedin-fill", link: contactObj.Linkedin },
	];
	return (
		<div className="right-content flex items-center gap-2">
			{data.map((item, index) => (
				<Link key={index} href={item.link} target="_blank" className="flex items-center gap-2">
					<i className={`${item.icon} text-[25px] text-black`}></i>
				</Link>
			))}
		</div>
	);
};

export default FollowUs;
